/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import classNames from "classnames";
import { components } from "react-select";

export const Control = ({ children, getValue, ...props }) => {
	const [{ value = false } = {}] = getValue();
	return (
		<components.Control {...props}>
			<i
				className={classNames(
					"glyphicon margin-left-10",
					value
						? "glyphicon-ok-sign color-primary"
						: "glyphicon glyphicon-remove color-danger",
				)}
			/>{" "}
			{children}
		</components.Control>
	);
};

export const Option = ({ children, data: { value }, ...props }) => (
	<components.Option {...props}>
		<i
			className={classNames(
				"glyphicon",
				value
					? "glyphicon-ok-sign color-primary"
					: "glyphicon glyphicon-remove color-danger",
			)}
		/>{" "}
		{children}
	</components.Option>
);
